import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function Profile() {
    const { currentUser, userProfile, reloadUserProfile } = useAuth();
    const navigate = useNavigate();

    const [displayName, setDisplayName] = useState(userProfile?.displayName || '');
    const [address, setAddress] = useState(userProfile?.address || '');
    const [notes, setNotes] = useState(userProfile?.notes || '');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [saving, setSaving] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            setSaving(true);

            await updateDoc(doc(db, 'users', currentUser.uid), {
                displayName: displayName.trim(),
                address: address.trim(),
                notes: notes.trim()
            });

            await reloadUserProfile();
            setSuccess('הפרופיל עודכן בהצלחה!');
            setSaving(false);
        } catch (err) {
            setError('שגיאה בעדכון הפרופיל: ' + err.message);
            setSaving(false);
        }
    }

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={{color: '#ffd966', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)', fontSize: 'clamp(20px, 5vw, 28px)', margin: '0', fontWeight: 'bold'}}>♠️♥️ הפרופיל שלי ♦️♣️</h1>
                <button
                    onClick={() => navigate('/dashboard')}
                    style={styles.backButton}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
                    }}
                >
                    ← חזרה
                </button>
            </div>

            <div style={styles.content}>
                <div style={styles.card}>
                    {error && <div style={styles.error}>{error}</div>}
                    {success && <div style={styles.success}>{success}</div>}

                    <form onSubmit={handleSubmit}>
                        <div style={styles.formGroup}>
                            <label style={styles.label}>שם מלא *</label>
                            <input
                                type="text"
                                value={displayName}
                                onChange={(e) => setDisplayName(e.target.value)}
                                required
                                style={styles.input}
                                dir="rtl"
                                onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                                onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>אימייל</label>
                            <input
                                type="email"
                                value={currentUser?.email || ''}
                                disabled
                                style={{...styles.input, backgroundColor: '#f0f0f0', opacity: 0.6}}
                            />
                            <small style={styles.helpText}>לא ניתן לשנות את האימייל</small>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>כתובת לאירוח</label>
                            <input
                                type="text"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="רחוב, עיר"
                                style={styles.input}
                                dir="rtl"
                                onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                                onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                            />
                            <small style={styles.helpText}>
                                הכתובת תשמש אוטומטית כשתארח משחק
                            </small>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>הערות לאירוח</label>
                            <textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                placeholder="קוד כניסה, קומה, מספר דירה, הנחיות חניה וכו׳"
                                style={{...styles.input, minHeight: '100px', resize: 'vertical'}}
                                dir="rtl"
                                onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                                onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={saving}
                            style={{
                                ...styles.saveButton,
                                opacity: saving ? 0.7 : 1,
                                cursor: saving ? 'not-allowed' : 'pointer',
                            }}
                            onMouseEnter={(e) => {
                                if (!saving) {
                                    e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(0, 112, 8, 0.6), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!saving) {
                                    e.target.style.transform = 'translateY(0) scale(1)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(0, 112, 8, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008';
                                }
                            }}
                        >
                            {saving ? '💾 שומר...' : '💾 שמור שינויים'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 50%, #1a1a1a 100%)',
        direction: 'rtl',
    },
    header: {
        backgroundColor: '#007008',
        padding: '20px 30px',
        boxShadow: '0 4px 15px rgba(0,0,0,0.8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '3px solid #ffd966',
    },
    backButton: {
        padding: '10px 20px',
        background: 'radial-gradient(circle at 30% 30%, #c0c0c0, #909090 40%, #c0c0c0)',
        color: '#000000',
        border: '3px solid #000000',
        borderRadius: '30px',
        cursor: 'pointer',
        fontWeight: 'bold',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(0,0,0,0.5), inset 0 0 0 1px #ffffff, inset 0 0 0 2px #c0c0c0',
    },
    content: {
        padding: '30px 20px',
        maxWidth: '600px',
        margin: '0 auto',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '35px',
        borderRadius: '15px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.8), inset 0 0 0 8px #ffffff, inset 0 0 0 12px #ffd966',
        border: '3px solid #000000',
        background: 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)',
    },
    error: {
        backgroundColor: '#ffe5e5',
        color: '#cc0000',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        border: '2px solid #cc0000',
    },
    success: {
        backgroundColor: '#e5f7e5',
        color: '#007008',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        border: '2px solid #007008',
        fontWeight: 'bold',
    },
    formGroup: {
        marginBottom: '20px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#000000',
        fontSize: '15px',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        border: '2px solid #c0c0c0',
        borderRadius: '8px',
        fontSize: '16px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        color: '#000000',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    helpText: {
        display: 'block',
        marginTop: '6px',
        fontSize: '13px',
        color: '#666666',
    },
    saveButton: {
        width: '100%',
        padding: '18px',
        background: 'radial-gradient(circle at 30% 30%, #007008, #005006 40%, #007008 60%, #005006)',
        color: '#ffffff',
        border: '4px solid #000000',
        borderRadius: '50px',
        fontSize: '17px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(0, 112, 8, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #007008',
        textTransform: 'uppercase',
        letterSpacing: '1.5px',
    },
};
